import styled from 'styled-components'

export const StepContainer = styled.div`
	flex: 1;
	overflow: auto;
	padding: 16px;
`
